import { NextSeo } from "next-seo";

import ContactForm from "elements/Contact-Form";
import HypothesisDiscovery from "elements/Technology/Hypothesis-Discovery";
import OptimizedCompute from "elements/Technology/Optimized-Compute";
import BusinessConsumption from "elements/Technology/Business-Consumption";

const Technology = () => {
  return (
    <>
      <NextSeo
        title="The Daisho Tech Engine"
        description="Daisho's tech solves everything required for Accelerated Problem Solving in a Business Context."
        canonical="https://www.daisho.ml/technology"
      />
      <section className="relative" id="technology">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="pt-32 pb-12 md:pt-40 px-2 border-b">
            <div
              data-aos="zoom-y-out"
              data-aos-delay={300}
              data-aos-anchor="#technology"
            >
              <HypothesisDiscovery />
            </div>
          </div>
          <div className="pt-12 pb-12 md:pt-16 px-2 border-b">
            <div
              data-aos="zoom-y-out"
              data-aos-delay={600}
              data-aos-anchor="#technology"
            >
              <OptimizedCompute />
            </div>
          </div>
          <div className="pt-12 pb-12 md:pt-16 px-2 border-b">
            <div
              data-aos="zoom-y-out"
              data-aos-delay={750}
              data-aos-anchor="#technology"
            >
              <BusinessConsumption />
            </div>
          </div>
        </div>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div
            className="pt-12 pb-12"
            data-aos="zoom-y-out"
            data-aos-delay={900}
            data-aos-anchor="#technology"
          >
            <ContactForm
              page="Technology"
              heading="Want to Have a Chat?"
              subtitle="We would love to talk."
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Technology;
